import { PromptView } from 'features/projects';

const ProjectPromptPage = () => <PromptView />;

export default ProjectPromptPage;
